import { ReactComponent as ArrowClockWise } from 'assets/icons/arrow-clock-wise.svg';

interface props {
    value?: number;
    fractionDigits?: number;
    maximunFractionDigits?: number;
    fill?: string;
}

export const RateBadge = ({
    value,
    maximunFractionDigits = 1,
    fractionDigits,
    fill = '#28323C',
}: props) => {
    const formatoptions: any = {};
    if (fractionDigits) {
        formatoptions.fraction = fractionDigits;
    } else {
        if (maximunFractionDigits) {
            formatoptions.maximumFractionDigits = maximunFractionDigits;
        }
    }

    const formatter = new Intl.NumberFormat('en-NZ', formatoptions);

    return (
        <div className="badge-percentage " style={{ display: 'flex', alignContent: 'center' }}>
            <ArrowClockWise fill={fill} />
            <div style={{ marginLeft: 4 }}>
                {value ? formatter.format(value).replace(/\D00(?=\D*$)/, '.0') : 0} %
            </div>
        </div>
    );
};
